// removed by extract-text-webpack-plugin
module.exports = {"searchWrapper":"TaskTemplateSearch__searchWrapper__2YkFZ","icon":"TaskTemplateSearch__icon__1skWq","clear":"TaskTemplateSearch__clear__YGRM3"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/TaskTemplateBlockOverview/TaskTemplateSearch/TaskTemplateSearch.scss
// module id = 1875
// module chunks = 0